// extracted by mini-css-extract-plugin
export var infoRow = "_pi-2";
export var labelContainer = "_pi-0";
export var rightInfo = "_pi-1";